import { render } from "./UldkasulikTooTabel.vue?vue&type=template&id=1677fb44&ts=true"
import script from "./UldkasulikTooTabel.vue?vue&type=script&lang=ts"
export * from "./UldkasulikTooTabel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__